import type { Pt } from './cgal';

export const PRESET_SPECS: Record<string, Pt[]> = {
  'rectangle 6×4': [
    [0, 0],
    [6, 0],
    [6, 4],
    [0, 4],
  ],
  'l-shape': [
    [0, 0],
    [6, 0],
    [6, 2],
    [2, 2],
    [2, 6],
    [0, 6],
  ],
  'asymmetric pentagon': [
    [0, 0],
    [10, 0],
    [10, 6],
    [7, 4],
    [0, 6],
  ],
  'complex heptagon': [
    [0, 0],
    [10, 0],
    [10, 5],
    [8, 3],
    [5, 5.5],
    [3, 3],
    [0, 5],
  ],
};
